import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: true,
})
export class FilterPipe implements PipeTransform {
    transform<T>(value: T[], predicate: (value: T, index: number) => boolean): T[] {
        return value.filter(predicate);
    }
}
